import { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import "../../assets/css/modal.css";
import PropTypes from "prop-types";
import { FiX } from 'react-icons/fi';
import { turnOnButton, turnOffButton } from './buttonFunctions';
import VerificationInput from './VerificationInput/VerificationInput';
import { doneLoading, load, confirmVerification, clearUserState } from '../../actions/userActions';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { ClearState } from '../../actions/authActions';
import './Verification.css';


const EmailVerification = (props) => {
  const [inputText, setInputText] = useState(Array(6).fill(""))
  const buttonElement = useRef(null)
  const [resendState, setResendState] = useState(false)
  const defaultValue = 60
  const [seconds, setSeconds] = useState(defaultValue)
  const interval = useRef(null)
  const [errorMessage, setErrorMessage] = useState("")

  const decrement = () => {
    setSeconds((previousState) => previousState - 1)
  }

  const hideModal = () => {

  }

const handleSubmit = (e) => {
  e.preventDefault(); 
  props.load();
  let fullInput = inputText.join("");
  setErrorMessage("");
  props.confirmVerification(fullInput);
};


useEffect(() => {
  if (props.user.correctCode) {
    props.setResetData({ ...props.resetData, token : props.user.correctCode.data.token,});

  props.verificationVisibility(false);
    props.confirmationVisibility(true);
  }
}, [props.user.correctCode]);

  useEffect(() => {
    if (props.user.errorMessage) {
      if (props.user.errorMessage.statusText === "Not Found") {
        setErrorMessage("Invalid verification code")
      }
    }
  }, [props.user.errorMessage]);

  useEffect(() => {
    if (inputText) {
      setErrorMessage("");
    }
  }, [inputText]);


  useEffect(() => {
    turnOnButton(buttonElement.current)

    let fullInput = inputText.join("")
    console.log(fullInput)
    if (fullInput?.length === 0 || fullInput?.length < 6) {
      turnOffButton(buttonElement?.current)
    }

  }, [inputText])


  useEffect(() => {
    if (seconds === 0) {
      clearInterval(interval.current)
      setResendState(false)
      interval.current = null
      setSeconds(defaultValue)
      setInputText([])
    }
  }, [seconds])

  return (
    <Modal
      show={props.show}
      dialogClassName="ev-dialog"
      contentClassName="ev-content"
      backdrop="static"
      keyboard={false}
      centered
    >
      <form onSubmit={handleSubmit}>
        <Modal.Body className="ev-body">
          <button
            type="button"
            className="ev-close-btn"
            aria-label="Close"
            onClick={() => {
              setErrorMessage("");
              props.clearUserState();
              clearInterval(interval.current);
              setResendState(false);
              interval.current = null;
              setSeconds(defaultValue);
              props.verificationVisibility(false);
              setInputText([]);
            }}
          >
            <FiX />
          </button>

          {/* Email icon */}
          <div className="ev-icon-ring">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="4" width="20" height="16" rx="2" />
              <polyline points="2,4 12,13 22,4" />
            </svg>
          </div>

          <div className="ev-heading">Complete verification</div>
          <div className="ev-subtitle">A verification code has been sent to your email</div>

          <div className="ev-label">Enter verification code</div>
          <VerificationInput maxLength={6} setInputText={setInputText} inputText={inputText} />
          <div className="ev-error">{errorMessage}</div>
        </Modal.Body>

        <Modal.Footer className="ev-footer">
          <div className="ev-resend">
            Didn't receive a code?&nbsp;
            <a
              onClick={() => {
                if (resendState === false) {
                  axios.post("/password/create", { email: props.passwordEmail }).catch((e) => console.log(e));
                  interval.current = setInterval(decrement, 1000);
                  setResendState(true);
                }
              }}
            >
              {resendState === false ? "Resend" : "Resend in " + seconds + "s"}
            </a>
          </div>
          <button
            className="ev-submit-btn"
            type="submit"
            disabled
            style={{ opacity: 0.5 }}
            ref={buttonElement}
          >
            Submit verification code
          </button>
          <div className="ev-powered">Powered by Warely</div>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default withTranslation()(
  connect(mapStateToProps, {
    load, doneLoading, confirmVerification, clearUserState
  })(EmailVerification)
);